// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects.
// *********************************
import * as i from '../interfaces/index';


export class Bank implements i.BankInterface {
    id: string;
    name: string;
    ibtCode: string;
    accountType: string;
    accountHolderName: string;
    accountNumber: string;
    mandateAuthorisedName: string;
    mandateReceived: Date;
    mandateDayFirst: number;
    mandateDayRest: number;
    default: boolean;

    static fromProto(proto: any): Bank {
        let m = new Bank();
        m = Object.assign(m, proto);
        if (proto.mandateReceived) {m.mandateReceived = new Date(proto.mandateReceived);}
        if (proto.mandateDayFirst) {m.mandateDayFirst = parseInt(proto.mandateDayFirst, 10);}
        if (proto.mandateDayRest) {m.mandateDayRest = parseInt(proto.mandateDayRest, 10);}
        return m;
    }

    constructor(kwargs?: i.BankInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.id === 'undefined' &&
            typeof this.name === 'undefined' &&
            typeof this.ibtCode === 'undefined' &&
            typeof this.accountType === 'undefined' &&
            typeof this.accountHolderName === 'undefined' &&
            typeof this.accountNumber === 'undefined' &&
            typeof this.mandateAuthorisedName === 'undefined' &&
            typeof this.mandateReceived === 'undefined' &&
            typeof this.mandateDayFirst === 'undefined' &&
            typeof this.mandateDayRest === 'undefined' &&
            typeof this.default === 'undefined') {
            return {};
        }
        
        const toReturn: {
            [key: string]: any;
        } = {};
        
        if (typeof this.id !== 'undefined') {toReturn['id'] = this.id;}
        if (typeof this.name !== 'undefined') {toReturn['name'] = this.name;}
        if (typeof this.ibtCode !== 'undefined') {toReturn['ibtCode'] = this.ibtCode;}
        if (typeof this.accountType !== 'undefined') {toReturn['accountType'] = this.accountType;}
        if (typeof this.accountHolderName !== 'undefined') {toReturn['accountHolderName'] = this.accountHolderName;}
        if (typeof this.accountNumber !== 'undefined') {toReturn['accountNumber'] = this.accountNumber;}
        if (typeof this.mandateAuthorisedName !== 'undefined') {toReturn['mandateAuthorisedName'] = this.mandateAuthorisedName;}
        if (typeof this.mandateReceived !== 'undefined' && this.mandateReceived !== null) {toReturn['mandateReceived'] = 'toApiJson' in this.mandateReceived ? (this.mandateReceived as any).toApiJson() : this.mandateReceived;}
        if (typeof this.mandateDayFirst !== 'undefined') {toReturn['mandateDayFirst'] = this.mandateDayFirst;}
        if (typeof this.mandateDayRest !== 'undefined') {toReturn['mandateDayRest'] = this.mandateDayRest;}
        if (typeof this.default !== 'undefined') {toReturn['default'] = this.default;}
        return toReturn;
    }
}

export class BillToAddress implements i.BillToAddressInterface {
    id: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    addressLine4: string;
    postalCode: string;
    city: string;
    province: string;
    default: boolean;

    static fromProto(proto: any): BillToAddress {
        let m = new BillToAddress();
        m = Object.assign(m, proto);
        return m;
    }

    constructor(kwargs?: i.BillToAddressInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.id === 'undefined' &&
            typeof this.addressLine1 === 'undefined' &&
            typeof this.addressLine2 === 'undefined' &&
            typeof this.addressLine3 === 'undefined' &&
            typeof this.addressLine4 === 'undefined' &&
            typeof this.postalCode === 'undefined' &&
            typeof this.city === 'undefined' &&
            typeof this.province === 'undefined' &&
            typeof this.default === 'undefined') {
            return {};
        }
        
        const toReturn: {
            [key: string]: any;
        } = {};
        
        if (typeof this.id !== 'undefined') {toReturn['id'] = this.id;}
        if (typeof this.addressLine1 !== 'undefined') {toReturn['addressLine1'] = this.addressLine1;}
        if (typeof this.addressLine2 !== 'undefined') {toReturn['addressLine2'] = this.addressLine2;}
        if (typeof this.addressLine3 !== 'undefined') {toReturn['addressLine3'] = this.addressLine3;}
        if (typeof this.addressLine4 !== 'undefined') {toReturn['addressLine4'] = this.addressLine4;}
        if (typeof this.postalCode !== 'undefined') {toReturn['postalCode'] = this.postalCode;}
        if (typeof this.city !== 'undefined') {toReturn['city'] = this.city;}
        if (typeof this.province !== 'undefined') {toReturn['province'] = this.province;}
        if (typeof this.default !== 'undefined') {toReturn['default'] = this.default;}
        return toReturn;
    }
}

export class ContactPerson implements i.ContactPersonInterface {
    id: string;
    firstName: string;
    surname: string;
    title: string;
    contactPosition: string;
    phoneNumber: string;
    faxNumber: string;
    mobileNumber: string;
    emailAddress: string;
    contractSigner: boolean;
    default: boolean;

    static fromProto(proto: any): ContactPerson {
        let m = new ContactPerson();
        m = Object.assign(m, proto);
        return m;
    }

    constructor(kwargs?: i.ContactPersonInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.id === 'undefined' &&
            typeof this.firstName === 'undefined' &&
            typeof this.surname === 'undefined' &&
            typeof this.title === 'undefined' &&
            typeof this.contactPosition === 'undefined' &&
            typeof this.phoneNumber === 'undefined' &&
            typeof this.faxNumber === 'undefined' &&
            typeof this.mobileNumber === 'undefined' &&
            typeof this.emailAddress === 'undefined' &&
            typeof this.contractSigner === 'undefined' &&
            typeof this.default === 'undefined') {
            return {};
        }
        
        const toReturn: {
            [key: string]: any;
        } = {};
        
        if (typeof this.id !== 'undefined') {toReturn['id'] = this.id;}
        if (typeof this.firstName !== 'undefined') {toReturn['firstName'] = this.firstName;}
        if (typeof this.surname !== 'undefined') {toReturn['surname'] = this.surname;}
        if (typeof this.title !== 'undefined') {toReturn['title'] = this.title;}
        if (typeof this.contactPosition !== 'undefined') {toReturn['contactPosition'] = this.contactPosition;}
        if (typeof this.phoneNumber !== 'undefined') {toReturn['phoneNumber'] = this.phoneNumber;}
        if (typeof this.faxNumber !== 'undefined') {toReturn['faxNumber'] = this.faxNumber;}
        if (typeof this.mobileNumber !== 'undefined') {toReturn['mobileNumber'] = this.mobileNumber;}
        if (typeof this.emailAddress !== 'undefined') {toReturn['emailAddress'] = this.emailAddress;}
        if (typeof this.contractSigner !== 'undefined') {toReturn['contractSigner'] = this.contractSigner;}
        if (typeof this.default !== 'undefined') {toReturn['default'] = this.default;}
        return toReturn;
    }
}

export class Customer implements i.CustomerInterface {
    internalCustomerId: string;
    name: string;
    website: string;
    externalCustomerId: string;
    businessIds: string[];
    creditBureauNumber: string;
    creditBureauRating: string;
    creditBureauDate: Date[];
    companyRegistrationNumber: string;
    creditVettingCode: string;
    vatRegistrationNumber: string;
    emailAddress: string;
    banks: Bank[];
    billToAddresses: BillToAddress[];
    contactPersons: ContactPerson[];

    static fromProto(proto: any): Customer {
        let m = new Customer();
        m = Object.assign(m, proto);
        if (proto.creditBureauDate) {m.creditBureauDate = proto.creditBureauDate.map((d: any) => new Date(d));}
        if (proto.banks) {m.banks = proto.banks.map(Bank.fromProto);}
        if (proto.billToAddresses) {m.billToAddresses = proto.billToAddresses.map(BillToAddress.fromProto);}
        if (proto.contactPersons) {m.contactPersons = proto.contactPersons.map(ContactPerson.fromProto);}
        return m;
    }

    constructor(kwargs?: i.CustomerInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.internalCustomerId === 'undefined' &&
            typeof this.name === 'undefined' &&
            typeof this.website === 'undefined' &&
            typeof this.externalCustomerId === 'undefined' &&
            typeof this.businessIds === 'undefined' &&
            typeof this.creditBureauNumber === 'undefined' &&
            typeof this.creditBureauRating === 'undefined' &&
            typeof this.creditBureauDate === 'undefined' &&
            typeof this.companyRegistrationNumber === 'undefined' &&
            typeof this.creditVettingCode === 'undefined' &&
            typeof this.vatRegistrationNumber === 'undefined' &&
            typeof this.emailAddress === 'undefined' &&
            typeof this.banks === 'undefined' &&
            typeof this.billToAddresses === 'undefined' &&
            typeof this.contactPersons === 'undefined') {
            return {};
        }
        
        const toReturn: {
            [key: string]: any;
        } = {};
        
        if (typeof this.internalCustomerId !== 'undefined') {toReturn['internalCustomerId'] = this.internalCustomerId;}
        if (typeof this.name !== 'undefined') {toReturn['name'] = this.name;}
        if (typeof this.website !== 'undefined') {toReturn['website'] = this.website;}
        if (typeof this.externalCustomerId !== 'undefined') {toReturn['externalCustomerId'] = this.externalCustomerId;}
        if (typeof this.businessIds !== 'undefined') {toReturn['businessIds'] = this.businessIds;}
        if (typeof this.creditBureauNumber !== 'undefined') {toReturn['creditBureauNumber'] = this.creditBureauNumber;}
        if (typeof this.creditBureauRating !== 'undefined') {toReturn['creditBureauRating'] = this.creditBureauRating;}
        if (typeof this.creditBureauDate !== 'undefined' && this.creditBureauDate !== null) {toReturn['creditBureauDate'] = 'toApiJson' in this.creditBureauDate ? (this.creditBureauDate as any).toApiJson() : this.creditBureauDate;}
        if (typeof this.companyRegistrationNumber !== 'undefined') {toReturn['companyRegistrationNumber'] = this.companyRegistrationNumber;}
        if (typeof this.creditVettingCode !== 'undefined') {toReturn['creditVettingCode'] = this.creditVettingCode;}
        if (typeof this.vatRegistrationNumber !== 'undefined') {toReturn['vatRegistrationNumber'] = this.vatRegistrationNumber;}
        if (typeof this.emailAddress !== 'undefined') {toReturn['emailAddress'] = this.emailAddress;}
        if (typeof this.banks !== 'undefined' && this.banks !== null) {toReturn['banks'] = 'toApiJson' in this.banks ? (this.banks as any).toApiJson() : this.banks;}
        if (typeof this.billToAddresses !== 'undefined' && this.billToAddresses !== null) {toReturn['billToAddresses'] = 'toApiJson' in this.billToAddresses ? (this.billToAddresses as any).toApiJson() : this.billToAddresses;}
        if (typeof this.contactPersons !== 'undefined' && this.contactPersons !== null) {toReturn['contactPersons'] = 'toApiJson' in this.contactPersons ? (this.contactPersons as any).toApiJson() : this.contactPersons;}
        return toReturn;
    }
}

